import React, { useState } from "react";

import MeterContainer from "../components/salesDocuments-v2/meterContainer";
import SalesDocHeader from "../components/salesDocuments-v2/salesDocHeader";

export interface CustomerDetailsProps {
  registrationNumber: string | null;
  typeOfBusiness: "Ltd" | "Sole Trader" | "Other" | "Charity" | "LLP" | "Registered society";
  businessAddress: string[];
}

export interface CustomerInfoProps {
  contactName: string;
  phoneNumber?: string;
  emailAddress: string;
  dateOfBirth?: string | null;
}

const SalesDocumentsV2: React.FC = () => {
  const [customerDetails, setCustomerDetails] = useState<CustomerDetailsProps | null>(null);
  const [customerInfo, setCustomerInfo] = useState<CustomerInfoProps | null>(null);
  const [companyName, setCompanyName] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerApiDataLoaded, setCustomerApiDataLoaded] = useState<boolean>(false);

  const customerInfoValid = !(
    customerDetails?.typeOfBusiness === "Sole Trader" && !customerInfo?.dateOfBirth
  );

  return (
    <div>
      <h1>Create a Sales Document</h1>
      <div id="sales-doc-container" className="justify-content-center">
        <SalesDocHeader
          customerDetails={customerDetails}
          setCustomerDetails={setCustomerDetails}
          customerInfo={customerInfo}
          setCustomerInfo={setCustomerInfo}
          companyName={companyName}
          setCompanyName={setCompanyName}
          customerId={customerId}
          setCustomerId={setCustomerId}
          customerApiDataLoaded={customerApiDataLoaded}
          setCustomerApiDataLoaded={setCustomerApiDataLoaded}
          customerInfoValid={customerInfoValid}
        />
        {customerApiDataLoaded && customerInfoValid && (
          <MeterContainer
            customerZohoId={customerId}
            customerDetails={customerDetails!}
            customerInfo={customerInfo!}
            companyName={companyName}
          />
        )}
      </div>
    </div>
  );
};

export default SalesDocumentsV2;
